"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CheckBoxContainer = function CheckBoxContainer(_ref) {
  var children = _ref.children,
      label = _ref.label;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      CheckedAll = _useState2[0],
      setCheckedAll = _useState2[1];

  var elements = _react.default.Children.toArray(children);

  var toggleCheckedAll = function toggleCheckedAll() {
    setCheckedAll(!CheckedAll);
  };

  return /*#__PURE__*/_react.default.createElement(CheckBoxContainerWrapper, null, /*#__PURE__*/_react.default.createElement(CheckBoxContainerHeader, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "title"
  }, label, label !== '' ? ' -' : '', ' '), /*#__PURE__*/_react.default.createElement(CheckBoxContainerToggler, {
    onClick: toggleCheckedAll
  }, CheckedAll ? 'Deselect all' : 'Select all')), elements.map(function (element) {
    return /*#__PURE__*/_react.default.cloneElement(element, {
      checked: CheckedAll,
      style: {
        marginBottom: '6px'
      }
    });
  }));
};

var CheckBoxContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "CheckBoxContainerWrapper"
})(["display:flex;flex-direction:column;font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var CheckBoxContainerHeader = _styledComponents.default.div.withConfig({
  displayName: "CheckBoxContainerHeader"
})(["margin-bottom:7px;.title{font-weight:500;font-size:1.4rem;line-height:120%;color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.highlight;
});

var CheckBoxContainerToggler = _styledComponents.default.a.withConfig({
  displayName: "CheckBoxContainerToggler"
})(["font-size:1rem;line-height:120%;color:", ";cursor:pointer;&:hover{text-decoration:underline;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.selected;
});

CheckBoxContainer.propTypes = {
  children: _propTypes.node,
  label: _propTypes.string
};
var _default = CheckBoxContainer;
exports.default = _default;